/** Prosjektkode i grått foran navnet, likt i alle tabellene på ansattkortet. */
export function ProjectCodeLabel({ code, name }: { code: string | null; name: string }) {
  return (
    <>
      {code && <span className="mr-2 inline-block min-w-[3.25rem] font-medium tabular-nums text-muted-foreground">{code}</span>}
      {name}
    </>
  );
}
